'use strict';

var GridAcceptHostShareButtonDirective = function GridAcceptHostShareButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-accept-host-share-button.html'),
    controller: 'GridAcceptHostShareButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
      $scope.$on('host-share:dropDownEvent', $scope.setAcceptButtonState);
    }
  };
};
GridAcceptHostShareButtonDirective.$inject = [];
module.exports = GridAcceptHostShareButtonDirective;